export default __webpack_public_path__ + "static/media/WSI.24e2a464.svg";